import React, { useCallback, useContext } from 'react';
import Raven from 'raven-js';

import { analyticService } from 'global/services';

import { LocaleContext } from 'app/containers/LocaleProvider';
import Responsive, { Mobile, Desktop } from 'app/components/Responsive';
import { BasketReceiptLanding } from 'app/views/Basket/components/BasketCheck/BasketReceiptLanding';

import { BasketContext } from '../../BasketProvider';
import { BillingContext } from '../../BillingProvider';
import { UserContext } from '../../UserProvider';
import BasketDishes from '../../BasketDishes';
import { BasketDishesSPAAdapter } from './BasketDishesSPAAdapter';

import s from './order-details-receipt.scss';


const locales = {
    ru: {
        titleMobile: 'Ваш заказ',
        titleDesktop: 'Оформить заказ',
    },
    en: {
        titleMobile: 'Order',
        titleDesktop: 'Order',
    },
};


export function OrderDetailsReceipt(props) {
    const {
        buttonsDisabled,
        basketDishes,
        pageId,
    } = props;

    const { locale } = useContext(LocaleContext);
    const l = locales[locale];

    const { userQuery: { user } } = useContext(UserContext);

    const {
        basket: {
            discount_conditions: promoocodeConditions,
            totals: {
                dishesPrice,
                deliveryPrice,
                promocode_amount: promocodeAmount,
                total_common_price: totalCommonPrice,
            },
        },
        refetchBasket,
    } = useContext(BasketContext);

    const {
        updateBilling,
        billingState: { promocode },
    } = useContext(BillingContext);

    const applyPromocodeHandler = useCallback(async ({ nextPromocode }) => {
        const phone = (user && user.phone) || '';

        try {
            await updateBilling({
                phone,
                promocode: nextPromocode,
            });
            const [basketResp] = await refetchBasket();

            const {
                data: { cart: { discount_conditions: dc } },
            } = basketResp;

            analyticService.push({
                eventName: 'Check_Send_Promo',
                sourceName: pageId,
                isPromoCodeExists: dc.isPromoCodeExists,
                promocodeStatus: dc.promocode_status,
                isPromocodeCombineWithDiscount: dc.isPromocodeCombineWithDiscount,
                isSubscriptionActivated: dc.isSubscriptionActivated,
                promo: dc.promocode,
            });

            return { promocodeConditions: dc };
        } catch (error) {
            Raven.captureException(error);
        }
    }, [updateBilling, refetchBasket, user, pageId]);

    return (
        <div className={s['order-details__container']}>
            <div className={s['order-details__title-container']}>
                <p className={s['order-details__title']}>
                    <Responsive
                        mobile={l.titleMobile}
                        desktop={l.titleDesktop}
                    />
                </p>
            </div>

            <Mobile>
                <BasketDishesSPAAdapter
                    locale={locale}
                    buttonsDisabled={buttonsDisabled}
                />
            </Mobile>

            <div className={s['order-details__receipt']}>
                <BasketReceiptLanding
                    dishesPrice={dishesPrice}
                    deliveryPrice={deliveryPrice}
                    promocodeAmount={promocodeAmount}
                    totalCommonPrice={totalCommonPrice}
                    promocodeConditions={promoocodeConditions}
                    applyPromocodeHandler={applyPromocodeHandler}
                    promocode={promocode}
                    isWelcomeDiscountShown={false}
                />
            </div>

            <Desktop>
                {basketDishes.length > 0 && (
                    <BasketDishes
                        hasTopIndent
                        dishes={basketDishes}
                        buttonsDisabled={buttonsDisabled}
                        showDeliveryPrice={false}
                    />
                )}
            </Desktop>
        </div>
    );
}
